<template>
    <div class="goods_info_center" v-if="manyspecss.is_det == 1">
        <!-- <div class="goods_info_list mr20" v-if="manyspecss.goodsattr.length >= 2">
            <span>{{manyspecss.goodsattr[0].name}}：{{tabs1}}</span>
            <ul>
                <li :class="[oneActive == index ? 'active' : '']" v-for="(item, index) in manyspecss.goodsattr[0].det" @click="normsclick(0, index, item.id)">
                    <img :src="item.img" v-if="item.img != ''" />
                    <span>{{item.name}}</span>
                </li>
            </ul>
        </div>
        <div class="goods_info_list mr10" v-if="manyspecss.length >= 3">
            <span>{{manyspecss.goodsattr[1].name}}：{{tabs2}}</span>
            <ul>
                <li :class="[twoActive == index ? 'active' : '']" v-for="(item, index) in manyspecss.goodsattr[1].det" @click="normsclick(1, index, item.id)">
                    <img :src="item.img" v-if="item.img != ''" />
                    <span>{{item.name}}</span>
                </li>
            </ul>
        </div>
        <div class="goods_info_norms_content">
            <div class="goods_info_norms_head">
                <Row>
                    <Col span="5"><span class="goods_info_norms_txt">型号</span></Col>
                    <Col span="7"><span class="goods_info_norms_txt">订货价</span></Col>
                    <Col span="6"><span class="goods_info_norms_txt">库存</span></Col>
                    <Col span="6">
                        <span class="goods_info_norms_txt">
                            起订{{manyspecss.minordernum}}{{manyspecss.unit}}
                            <span v-if="manyspecss.doubleunit == 2">1{{manyspecss.maxunit}}={{manyspecss.matrixing}}{{manyspecss.unit}}</span>
                        </span>
                    </Col>
                </Row>
            </div>
            <div
                class="goods_info_norms_body"
                v-if="manyspecss.goodsattr[(manyspecss.goodsattr.length == 1 ? 0 : (manyspecss.goodsattr.length == 2 ? 1 : 2))]"
            >
                <Row
                    class="goods_info_norms_body_list"
                    v-for="(i, index) in manyspecss.goodsattr[(manyspecss.goodsattr.length == 1 ? 0 : (manyspecss.goodsattr.length == 2 ? 1 : 2))].det"
                    :key="index"
                >
                    <Row
                        v-for="(j, index) in manyspecss.det"
                        :key="index"
                        v-if="(manyspecss.goodsattr.length == 1 ? i.id : (manyspecss.goodsattr.length == 2 ? tabs1 + ',' + i.id : tabs1 + ',' + tabs2 + ',' + i.id)) == j.gg_ids"
                    >
                        <Col span="5"><span class="goods_info_norms_txt">{{i.name}}</span></Col>
                        <Col span="7"><span class="goods_info_norms_txt">¥{{j.cost}}（{{j.market_cost}}）/{{manyspecss.unit}}</span></Col>
                        <Col span="6"><span class="goods_info_norms_txt">{{j.stock || 0}}{{manyspecss.unit}}</span></Col>
                        <Col span="6">
                            <div class="goods_list_num_content" v-if="j.stock != 0 && j.stock != null">
                                <div class="goods_list_num">
                                    <span @click="minBtn(j)">-</span>
                                    <InputNumber class="goodsnum" v-model="j.num" :min="0"></InputNumber>
                                    <span @click="addBtn(j)">+</span>
                                </div>
                                <Tooltip :content="manyspecss.unitshow ? manyspecss.maxunit : manyspecss.unit" theme="light" placement="top">
                                    <div class="goods_list_unit" :style="{width: manyspecss.doubleunit == 1 ? '23px' : ''}" @click.stop="unitChange(manyspecss.unitshow)">{{manyspecss.unitshow ? manyspecss.maxunit : manyspecss.unit}}<i class="icon iconfont icon-xialazhankai" v-if="manyspecss.doubleunit == 2"></i></div>
                                </Tooltip>
                            </div>
                            <span class="goods_info_norms_txt" v-else>缺货</span>
                        </Col>
                    </Row>
                </Row>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        props: ['outstock', 'manyspecs', 'normselect'],
        data() {
            return {
                oneActive: 0, // 第一个分类当前选中
                twoActive: 0, // 第二个分类当前选中
                goodslists: [], // 商品
                normss: [], // 商品规格
                goodsdets: [], // 商品规格组合价格
                goodsid: '', // 商品规格选中id, 使用逗号分割
                specs: true,
                manyspecss: {}
            }
        },
        methods: {
            normsclick (sign, index, id) { // 点击切换商品规格 sign 如果norms大于1条 表示第一行的
                let arr = []
                arr = this.goodsid.split(',')
                if (sign == 0) {
                    this.oneActive = index
                    arr[0] = this.tabs1 = id
                } else if (sign == 1) {
                    this.twoActive = index
                    arr[1] = this.tabs2 = id
                }
                this.goodsid = arr.join(',')
                this.$emit('getNormsId', this.goodsid)
            },
            defaultspecs () { // 默认选中规格
                // if (this.specs) {
                //     if (this.norms.goodsattr.length == 1) {
                //         this.goodsid = this.norms.goodsattr[0].det[0].id + ''
                //     } else if (this.norms.goodsattr.length == 2) {
                //         this.goodsid = this.norms.goodsattr[0].det[0].id + ',' + this.norms.goodsattr[1].det[0].id
                //         this.tabs1 = this.norms.goodsattr[0].det[0].id
                //     } else if (this.norms.goodsattr.length == 3) {
                //         this.goodsid = this.norms.goodsattr[0].det[0].id + ',' + this.norms.goodsattr[1].det[0].id + ',' + this.norms.goodsattr[2].det[0].id
                //         this.tabs1 = this.norms.goodsattr[0].det[0].id
                //         this.tabs2 = this.norms.goodsattr[1].det[0].id
                //     }
                //     this.specs = false
                // }
            },
            unitChange (show) { // 切换大小规格
                if (this.manyspecss.doubleunit == 2) {
                    this.manyspecss.unitshow = !show
                }
            },
            minBtn (item) { // 减数量
                item.num <= 0 ? item.num = 0 : item.num--
            },
            addBtn (item) { // 加数量
                // console.log(item.gg_attrname)
                // console.log(item.gg_id)
                // console.log(item.gg_ids)
                if (item.num >= item.stock && this.outstock > 0) {
                    item.num = parseInt(item.stock)
                    this.$Message.warning('库存为' + item.stock + '个,不可超库存下单')
                } else {
                    item.num++
                }
            },
        },
        watch: {
            manyspecs: {
                handler () {
                    console.log('改变了')
                    this.manyspecss = this.manyspecs
                    // if (this.manyspecs.goodsattr.length == 1) {
                    //     this.goodsid = this.manyspecs.goodsattr[0].det[0].id + ''
                    // } else if (this.manyspecs.goodsattr.length == 2) {
                    //     this.goodsid = this.manyspecs.goodsattr[0].det[0].id + ',' + this.manyspecs.goodsattr[1].det[0].id
                    //     this.tabs1 = this.manyspecs.goodsattr[0].det[0].id
                    // } else if (this.manyspecs.goodsattr.length == 3) {
                    //     this.goodsid = this.manyspecs.goodsattr[0].det[0].id + ',' + this.manyspecs.goodsattr[1].det[0].id + ',' + this.manyspecs.goodsattr[2].det[0].id
                    //     this.tabs1 = this.manyspecs.goodsattr[0].det[0].id
                    //     this.tabs2 = this.manyspecs.goodsattr[1].det[0].id
                    // }
                },
                deep: true
            },
            normselect () {
                this.oneActive = this.twoActive = 0
            },
            goodsid () {
                this.$emit('getNormsId', this.goodsid)
            }
        }
    }
    

function deepClone (data) { // 深度拷贝
    var type = typeof(data)
    var obj
    if (type === 'array' || Array.isArray(data)) {
        obj = []
    } else if (type === 'object') {
        obj = {}
    } else {
        //不再具有下一层次
        return data
    }
    if (type === 'array' || Array.isArray(data)) {
        for (var i = 0, len = data.length; i < len; i++) {
            obj.push(deepClone(data[i]))
        }
    } else if (type === 'object') {
        for (var key in data) {
            obj[key] = deepClone(data[key])
        }
    }
    return obj
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/component/goodsnorms.vue